import * as deprecationPanelDefinitions from './deprecationPanelDefinitions';

export { deprecationPanelDefinitions };
